import React from "react";
interface IfComponentProps {
    /** The condition that needs to be fullfilled in order to render the prop "then" */
    condition: boolean;
    /** React element that is rendered when the condition prop is fulfilled  */
    then: React.ReactElement;
    /** React element that is rendered when the condition prop is not fulfilled  */
    else: React.ReactElement | null;
}
/**
 * Component for conditional rendering. \n
 * @example <If condition={1+1 === 2} then={"hello"} else={"goodbye"} />
 * Renders "hello"
 */
export function If(props: IfComponentProps) {
    const condition = props.condition || false;
    const positive = props.then || null;
    const negative = props.else || null;

    return condition ? positive : negative;
}
